import { SystemStatus } from "./tabs/system-status";
import { GeneralSettings } from "./tabs/general-settings";
import { useTranslation } from "react-i18next";
import { useState } from "react";
import { Color } from "utils/theme";
import { DataExport } from "./tabs/data-export";
import { SystemInformation } from "./tabs/system-information";
import { SystemSettings } from "./tabs/system-settings";
import { Button } from "components/ui/button";
import { useStore } from "hooks/use-store";
import { DEV_TOOLS_ENABLED } from "utils/constants";

export const SettingsScreen = () => {
  const { t } = useTranslation("translation", { keyPrefix: "settings" });
  const setShowDevTools = useStore((state) => state.setShowDevTools);

  const TabNavigation = [
    {
      title: t("tab_titles.general_settings"),
      key: "general_settings",
      content: GeneralSettings,
    },
    {
      title: t("tab_titles.system_status"),
      key: "system_status",
      content: SystemStatus,
    },
    {
      title: t("tab_titles.system_settings"),
      key: "system_settings",
      content: SystemSettings,
    },
    {
      title: t("tab_titles.data_export"),
      key: "data_export",
      content: DataExport,
    },
    {
      title: t("tab_titles.system_info"),
      key: "system_info",
      content: SystemInformation,
    },
  ];

  const [tab, setTab] = useState(TabNavigation[0].key);
  const SelectedTab = TabNavigation.find((t) => t.key === tab);

  return (
    <div className="h-full overflow-hidden flex flex-col md:flex-row">
      <div
        className="flex shrink-0 flex-row md:flex-col w-full md:w-fit h-fit md:h-full overflow-auto py-3 md:p-2 space-x-2 md:space-x-0 md:space-y-2 border-r"
        style={{
          background: Color.Primary[900],
          borderColor: Color.Primary[700],
        }}
      >
        <h3 className="hidden md:block font-medium text-lg mt-2 mb-1 px-3">
          {t("title")}
        </h3>
        {TabNavigation.map((t) => {
          const isSelected = t.key === tab;

          return (
            <Button
              key={t.key}
              onClick={() => setTab(t.key)}
              variant={isSelected ? "secondary" : "ghost"}
              className="flex items-center justify-start md:min-w-[150px] lg:min-w-[200px]"
            >
              <p
                className="w-full text-left"
                style={{
                  color: isSelected ? Color.Primary[100] : Color.Primary[400],
                }}
              >
                {t.title}
              </p>
            </Button>
          );
        })}
        {DEV_TOOLS_ENABLED && (
          <Button
            onClick={() => setShowDevTools(true)}
            variant="ghost"
            className="flex items-center justify-start gap-2 md:min-w-[150px] lg:min-w-[200px] md:!mt-auto"
          >
            <p
              className="w-full text-left"
              style={{ color: Color.Primary[400] }}
            >
              Developer Tools
            </p>
          </Button>
        )}
      </div>
      {SelectedTab && (
        <div className="overflow-hidden flex-1 flex flex-col">
          <SelectedTab.content title={SelectedTab.title} />
        </div>
      )}
    </div>
  );
};
